/* Lovely Nursery – shared storefront behaviour */
(function () {
  if (window.LN) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toastEl, toastTimer;

  function money(cents) {
    var v = (cents / 100);
    return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ln-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 4200);
  }

  function refreshCartBubble() {
    return fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        target.innerHTML = src.innerHTML;
      }).catch(function () {});
  }

  function addToCart(form, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.innerHTML = 'Adding…'; }
    var body = new FormData(form);
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast('<span>' + (res.data.description || res.data.message || 'Could not add to cart') + '</span>');
          return;
        }
        var item = res.data;
        var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '';
        toast(img + '<span><strong>Added to cart</strong><br>' + item.product_title + (item.variant_title ? ' – ' + item.variant_title : '') + '</span><a href="' + root + 'cart">View cart →</a>');
        refreshCartBubble();
        document.dispatchEvent(new CustomEvent('ln:cart-added', { detail: item }));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ln-atc]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  // Card variant dropdown -> price + button state
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-ln-card-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.ln-card');
    if (!card) return;
    var now = card.querySelector('.ln-price__now');
    var was = card.querySelector('.ln-price__was');
    var off = card.querySelector('.ln-price__off');
    var price = +opt.dataset.price, compare = +opt.dataset.compare || 0;
    if (now) now.textContent = money(price);
    if (was) { was.textContent = compare > price ? money(compare) : ''; }
    if (off) { off.textContent = compare > price ? Math.round((compare - price) * 100 / compare) + '% off' : ''; }
    var btn = card.querySelector('.ln-card__form [type="submit"]');
    if (btn) {
      var avail = opt.dataset.available === 'true';
      btn.disabled = !avail;
      btn.textContent = avail ? 'Add to cart' : 'Sold out';
    }
  });

  // Tabs (product tabs section)
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-ln-tab]');
    if (!tab) return;
    var group = tab.closest('[data-ln-tabs]');
    group.querySelectorAll('[data-ln-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on);
      t.classList.toggle('is-active', on);
    });
    group.querySelectorAll('[data-ln-panel]').forEach(function (p) {
      p.hidden = p.dataset.lnPanel !== tab.dataset.lnTab;
    });
    var link = group.querySelector('[data-ln-viewall]');
    if (link && tab.dataset.url) link.href = tab.dataset.url;
  });

  window.LN = { money: money, toast: toast, addToCart: addToCart, refreshCartBubble: refreshCartBubble };
})();
